import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { organizedNeeds, productName, systemFlow } from '../data/content';
import { Mark, SectionTitle } from './ui/Section';
export function ProblemSolution() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-174" data-mp="3mr2xsp5146pt">
      <div className="mx-auto max-w-5xl" data-id="element-175" data-mp="3hrghu7xtgcdb">
        <SectionTitle data-id="element-176" data-mp="3hsrkg4fize2u">
          What if your manual therapy sessions <Mark data-id="element-177" data-mp="icl7agxhhihh">were already organized?</Mark>
        </SectionTitle>
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-slate-600 md:text-base" data-id="element-178" data-mp="idwaaej3um7j">
          You already know dozens of techniques. The challenge is choosing the right one, positioning the patient,
          organizing the time, and integrating appropriate exercise. <strong className="text-brand-deep" data-id="element-179" data-mp="4keth1hsznl7">{productName}</strong>{' '}
          brings it all together in one professional collection.
        </p>
        <p className="mt-5 text-center text-sm font-black uppercase tracking-[.2em] text-brand" data-id="element-180" data-mp="x8ssnkkmopyc">
          Assess. Select. Apply. Move. Reassess.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-181" data-mp="6ulrgtytv1wy">
          <div className="flex flex-col rounded-2xl border border-brand/10 bg-slate-50 p-6" data-id="element-182" data-mp="bqkfuhk5ojxd">
            <h3 className="text-base font-black uppercase leading-tight text-brand-deep md:text-lg" data-id="element-183" data-mp="3u4jvj68wsnfl">
              Turn scattered techniques into clear, professional sessions
            </h3>
            <div className="mt-3 flex-1 space-y-2 text-sm leading-relaxed text-slate-600" data-id="element-184" data-mp="3k75o1w4yr8zf">
              <p data-id="element-185" data-mp="3p71lfcj5o260">
                Techniques saved from videos, courses, notes, and textbooks quickly become hard to organize — and a
                complete session requires more than remembering where to place your hands.
              </p>
              <p data-id="element-186" data-mp="3f8m4219xk79p">
                Each volume gives you anatomical references, contact instructions, step-by-step procedures,
                modifications, and session templates in one place.
              </p>
            </div>
            <p className="mt-5 text-xs font-black uppercase tracking-wider text-brand" data-id="element-187" data-mp="2mdwb32z4ldzf">
              More structure. More confidence. Better clinical organization.
            </p>
          </div>

          <div className="flex flex-col rounded-2xl bg-brand p-6" data-id="element-188" data-mp="2dd7x289qfdmj">
            <h3 className="text-base font-black uppercase leading-tight text-white md:text-lg" data-id="element-189" data-mp="2ddrcnibwtpxe">
              One system. Five body regions. <span className="text-gold-light" data-id="element-190" data-mp="28ghf1feda7yh">Ready to use.</span>
            </h3>
            <ul className="mt-4 flex-1 space-y-2.5" data-id="element-191" data-mp="356i299z38gdo">
              {organizedNeeds.map(item => <li key={item.question} className="flex items-start gap-2 text-sm text-white/85" data-id="element-192" data-mp="314wsvylrik88">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-light" aria-hidden="true" data-id="element-193" data-mp="2w9zbo4ebx4k9" />
                  <span data-id="element-194" data-mp="2rawfl9gbu8of">
                    {item.question} <strong className="font-bold text-white" data-id="element-195" data-mp="3osms36idrvf0">{item.answer}</strong>
                  </span>
                </li>)}
            </ul>
            <ol className="mt-5 flex flex-wrap items-center gap-1.5" data-id="element-196" data-mp="3jztown2k8v51">
              {systemFlow.map((step, index) => <li key={step} className="flex items-center gap-1.5" data-id="element-197" data-mp="69ms3gt43zd" data-mpi={index}>
                  {index > 0 && <ArrowRightIcon className="h-3.5 w-3.5 text-gold-light" aria-hidden="true" data-id="element-198" data-mp="55ma0pblbd2h" />}
                  <span className="whitespace-nowrap rounded-md bg-white px-2 py-1 text-[10px] font-black uppercase tracking-wide text-brand-deep" data-id="element-199" data-mp="57yy7k7xyjnz">
                    {step}
                  </span>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}